import React, { lazy } from 'react';
import { PRODUCT_IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function PackComposite() {
  return <section className="bg-white py-16 px-4" data-id="element-211">
      <div className="max-w-7xl mx-auto text-center" data-id="element-212">
        <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-4" data-id="element-213">
          Tutto questo è tuo oggi
        </h2>
        <p className="text-xl text-gray-600 mb-12" data-id="element-214">
          5 risorse complete + 4 bonus gratuiti
        </p>

        <div className="relative h-[350px] md:h-[500px] mb-8 cursor-pointer group" onClick={scrollToOffer} data-id="element-215">
          {/* Orange glow effect */}
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-216">
            <div className="w-[300px] h-[300px] bg-orange-400 rounded-full blur-3xl opacity-20" data-id="element-217"></div>
          </div>

          {/* Tomo 2 */}
          <img src={PRODUCT_IMAGES.tomo2} alt="Giochi e Attività" className="absolute left-[2%] top-[18%] w-[18%] md:w-[20%] transform -rotate-12 shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:-translate-x-8 group-hover:-translate-y-4" loading="lazy" data-id="element-218" />
          {/* Tomo 3 */}
          <img src={PRODUCT_IMAGES.tomo3} alt="Mindfulness ed Emozioni" className="absolute left-[16%] top-[8%] w-[18%] md:w-[20%] transform -rotate-6 shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:-translate-x-4 group-hover:-translate-y-2" loading="lazy" data-id="element-219" />
          {/* Main Product */}
          <img src={PRODUCT_IMAGES.main} alt="Mega-Pack Yoga per Bambini" className="absolute left-1/2 top-[3%] w-[30%] transform -translate-x-1/2 shadow-2xl z-30 transition-all duration-500 group-hover:scale-110" data-id="element-220" />
          {/* Tomo 4 */}
          <img src={PRODUCT_IMAGES.tomo4} alt="Carte e Poster Posizioni" className="absolute right-[16%] top-[8%] w-[18%] md:w-[20%] transform rotate-6 shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:translate-x-4 group-hover:-translate-y-2" loading="lazy" data-id="element-221" />
          {/* Tomo 5 */}
          <img src={PRODUCT_IMAGES.tomo5} alt="Famiglia e Scuola" className="absolute right-[2%] top-[18%] w-[18%] md:w-[20%] transform rotate-12 shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:translate-x-8 group-hover:-translate-y-4" loading="lazy" data-id="element-222" />
        </div>
      </div>
    </section>;
}